import React from "react";
import { TableRow, TableCell, Box, Typography, TableHead } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
  header: {
    background: theme.gradient,
    backgroundAttachment: "fixed", // Fix for IE
    backgroundRepeat: "no-repeat" // Fix for IE
  },
  headerText: {
    marginRight: theme.spacing(1.75)
  }
}));

function AnnouncementsListHead(props) {
  const classes = useStyles();
  const { adminView } = props;

  return (
    <TableHead className={classes.header}>
      <TableRow>
        {adminView && <TableCell padding="checkbox" />}
        <TableCell>
          <Box display="flex" color="white">
            <Typography variant="subtitle2" className={classes.headerText}>
              Title
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box display="flex" color="white">
            <Typography variant="subtitle2" className={classes.headerText}>
              Post Date
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box display="flex" color="white">
            <Typography variant="subtitle2" className={classes.headerText}>
              End Date
            </Typography>
          </Box>
        </TableCell>
        {adminView && (
          <TableCell>
            <Box display="flex" color="white">
              <Typography variant="subtitle2" className={classes.headerText}>
                Status
              </Typography>
            </Box>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

AnnouncementsListHead.propTypes = {
  adminView: PropTypes.bool
};
AnnouncementsListHead.defaultProps = {
  adminView: false
};

export default AnnouncementsListHead;
